<template>
  <label class="eds-checkbox" :class="[labelClass]" :style="labelStyle">
    <input
      v-bind="$attrs"
      type="checkbox"
      class="checkbox-input"
      :class="inputClass"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('update:checked', ($event.target as any)?.checked)"
    />
    <span
      class="checkbox-label"
      :class="[checkboxLabelClass]"
      :style="[checkboxLabelStyle]"
    >
      <slot />
      <div v-if="!$slots.default">
        {{ label }}
      </div>
    </span>
  </label>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Checkbox',
    inheritAttrs: false,
    emits: ['update:checked'],
    props: {
      checked: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      label: {
        type: String,
        required: false,
        default: 'Checkbox',
      },
      inputClass: {
        type: String,
        required: false,
        default: '',
      },
      labelClass: {
        type: String,
        required: false,
        default: '',
      },
      labelStyle: {
        type: Object,
        required: false,
      },
      checkboxLabelClass: {
        type: String,
        required: false,
        default: '',
      },
      checkboxLabelStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>

<style></style>
